export default {"src":"/_next/static/media/swisschard.61a6f5be.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};